var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    x: 1.25,
    y: 1.25,
    fill: "url(#a)",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    x: 1.25,
    y: 1.25,
    fill: "url(#b)",
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    x: 1.25,
    y: 1.25,
    fill: "url(#c)",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.375 6.563a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Zm0-1.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 9.75c0-2.1 0-3.15.409-3.952a3.75 3.75 0 0 1 1.639-1.64C6.6 3.75 7.65 3.75 9.75 3.75h.5c2.1 0 3.15 0 3.953.409a3.75 3.75 0 0 1 1.638 1.639c.409.802.409 1.852.409 3.952v.5c0 2.1 0 3.15-.409 3.953a3.75 3.75 0 0 1-1.638 1.638c-.803.409-1.853.409-3.953.409h-.5c-2.1 0-3.15 0-3.952-.409a3.75 3.75 0 0 1-1.64-1.638C3.75 13.4 3.75 12.35 3.75 10.25v-.5Zm6-4.75h.5c1.07 0 1.799.001 2.361.047.548.045.829.126 1.024.225a2.5 2.5 0 0 1 1.092 1.093c.1.196.181.476.226 1.024C15 7.95 15 8.679 15 9.75v.5c0 1.07-.001 1.799-.047 2.361-.045.548-.126.829-.226 1.024a2.5 2.5 0 0 1-1.092 1.092c-.195.1-.476.181-1.024.226-.562.046-1.29.047-2.361.047h-.5c-1.07 0-1.799-.001-2.361-.047-.548-.045-.828-.126-1.024-.226a2.5 2.5 0 0 1-1.093-1.092c-.1-.195-.18-.476-.225-1.024C5 12.05 5 11.321 5 10.25v-.5c0-1.07.001-1.799.047-2.361.045-.548.126-.828.225-1.024a2.5 2.5 0 0 1 1.093-1.093c.196-.1.476-.18 1.024-.225C7.95 5 8.679 5 9.75 5Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-55.376 17.447 .041) scale(15.9498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-65.136 18.604 4.306) scale(14.1214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.0625 -3.4375 .73525 5.14672 .313 1.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.d1a82b7cc643db28820f49e15293e87c.svg";
export { ForwardRef as ReactComponent };